// extracted by mini-css-extract-plugin
export default {"container":"H1SVgVGE","card":"v17sIiZd","header":"_AAxm9XG","title":"uOjf0OPU","label":"hkl1UsnH","name":"fLeznjXd","buttons":"IisJWmZX","form":"Tc_lakpq"};